import { Plan } from '../../../Templates/Plan';

export function City({ kernel }) {
    return <Plan endpoint='/plans/city.json' />
}
